/**
 * Truncate text based on character limit.
 * If limit exceeds, '...' will be added to end of the text.
 */
const truncateText = (text: string, limit: number) =>
  text.length < limit ? text : text.slice(0, limit - 2) + '...'

export { truncateText }
